import { render, staticRenderFns } from "./DiscountShow.vue?vue&type=template&id=e0a8960c"
import script from "./DiscountShow.vue?vue&type=script&lang=ts"
export * from "./DiscountShow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports